
export function getCategorySlugFromURI(uri = "") {
  return uri.replace(/^\//, '').split('/').slice(1).join('/') // remove prefix added by wordpress
}
